import { addDaysToDate } from "src/utils/format-time";
import { _mock } from "./_mock";

const itemsVariants = [
  [0, 4],
  [1, 3],
  [1, 2],
  [3, 4],
  [0, 2],
  [1, 4],
];

const paymentMethodVariants = [[0, 1], [1, 2], [0]];

export const _phases = [...Array(12)].map((_, index) => {
  const itemVariant = Math.round(Math.random() * 4);
  const venues = itemsVariants[itemVariant];
  const paymentMethods = paymentMethodVariants[Math.floor(Math.random() * 3)];

  return {
    id: Math.floor(Math.random() * 1000),
    providerId: Math.floor(Math.random() * 1000),
    venues: venues,
    periodStart: _mock.time(index),
    periodEnd: addDaysToDate(_mock.time(index), 30, "plus"),
    daysHoursPrices: ["", ""],
    paymentType: Math.floor(Math.random()),
    paymentMethods: paymentMethods,
    description: _mock.description(index),
    view: true,
    createdAt: _mock.time(index),
  };
});
